export const ADMIN = 'Admin';
export const DEPARTAMENTO_TECNICO = 'Departamento tecnico';
export const JEFE_LABORATORIO = 'Jefe laboratorio';
export const LABORATORISTA = 'Laboratorista';

export const LISTA_ROLES_CREAR_EDITAR = [
  DEPARTAMENTO_TECNICO,
  JEFE_LABORATORIO,
] as const;
